<div class="dashboard-content" style="padding: 120px 40px 50px">
  <section>
    <div class="contests-back-icon" (click)="goBack()">
      <span class="back-btn">
        <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
          <rect width="52" height="52" rx="26" fill="#F5F5F9" />
          <path d="M18 26H34" stroke="#586277" stroke-width="1.53752" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M23 31C23 31 18 27.3176 18 26C18 24.6824 23 21 23 21" stroke="#586277" stroke-width="1.53752"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </span>
    </div>

    <div class="analysis-contests-container">
      <div class="head">
        <div class="heading mt-3">
          <div>
            <h1 class="contests-header mt-0">
              {{ "contestMonitoring.heading" | translate }}
            </h1>
          </div>

          <div class="d-flex align-items-center gap-3">
            <!-- Filter Button -->
            <button class="btn d-flex justify-content-center align-items-center custom-btn "
              (click)="showFilterModal()">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                <path d="M3.0459 7H6.0459" stroke="#141B34" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M3.0459 17H9.0459" stroke="#141B34" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M18.0459 17H21.0459" stroke="#141B34" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M15.0459 7H21.0459" stroke="#141B34" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M6.0459 7C6.0459 6.06812 6.0459 5.60218 6.19814 5.23463C6.40113 4.74458 6.79048 4.35523 7.28053 4.15224C7.64808 4 8.11402 4 9.0459 4C9.97778 4 10.4437 4 10.8113 4.15224C11.3013 4.35523 11.6907 4.74458 11.8937 5.23463C12.0459 5.60218 12.0459 6.06812 12.0459 7C12.0459 7.93188 12.0459 8.39782 11.8937 8.76537C11.6907 9.25542 11.3013 9.64477 10.8113 9.84776C10.4437 10 9.97778 10 9.0459 10C8.11402 10 7.64808 10 7.28053 9.84776C6.79048 9.64477 6.40113 9.25542 6.19814 8.76537C6.0459 8.39782 6.0459 7.93188 6.0459 7Z"
                  stroke="#141B34" stroke-width="1.5" />
                <path
                  d="M12.0459 17C12.0459 16.0681 12.0459 15.6022 12.1981 15.2346C12.4011 14.7446 12.7905 14.3552 13.2805 14.1522C13.6481 14 14.114 14 15.0459 14C15.9778 14 16.4437 14 16.8113 14.1522C17.3013 14.3552 17.6907 14.7446 17.8937 15.2346C18.0459 15.6022 18.0459 16.0681 18.0459 17C18.0459 17.9319 18.0459 18.3978 17.8937 18.7654C17.6907 19.2554 17.3013 19.6448 16.8113 19.8478C16.4437 20 15.9778 20 15.0459 20C14.114 20 13.6481 20 13.2805 19.8478C12.7905 19.6448 12.4011 19.2554 12.1981 18.7654C12.0459 18.3978 12.0459 17.9319 12.0459 17Z"
                  stroke="#141B34" stroke-width="1.5" />
              </svg>
              <span class="row-button">
                {{ "contestMonitoring.filter" | translate }}
              </span>
            </button>
            <!-- Cross Icon (Clear) -->
            <span *ngIf="hasActiveFilters() || searchTerm"
              class="position-absolute d-flex justify-content-center align-items-center pulse-badge"
              (click)="clearAllFilters()">
              ✕
            </span>

            <!-- Export Report Dropdown -->
            <div class="dropdown export-dropdown">
              <button class="Download-button dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff"
                  fill="none">
                  <path
                    d="M18.25 8.99997C20.3077 9.07357 22.0549 10.6169 21.9987 12.6843C21.9856 13.1653 21.7993 13.7598 21.4266 14.9488C20.5298 17.8104 19.0226 20.2944 15.6462 20.8904C15.0255 21 14.3271 21 12.9303 21H11.0697C9.6729 21 8.9745 21 8.35384 20.8904C4.97739 20.2944 3.47018 17.8104 2.57336 14.9488C2.20072 13.7598 2.01439 13.1653 2.00132 12.6843C1.94512 10.6169 3.6923 9.07357 5.75001 8.99997"
                    stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"></path>
                  <path
                    d="M12 14L12 3M12 14C11.2998 14 9.99153 12.0057 9.5 11.5M12 14C12.7002 14 14.0085 12.0057 14.5 11.5"
                    stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ "contestMonitoring.excel" | translate }}</span>
                <i class="fa-solid fa-angle-down ms-2"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-end">
                <li>
                  <a class="dropdown-item" href="javascript:void(0)" (click)="downloadPDF()">
                    <i class="fa-solid fa-file-pdf me-2" style="color: #e74c3c;"></i>
                    PDF
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="javascript:void(0)" (click)="downloadExcel()">
                    <i class="fa-solid fa-file-excel me-2" style="color: #27ae60;"></i>
                    Excel
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
      <div class="cards-container">
        <div class="row">
          <div class="col-md-3 col-sm-6" *ngFor="let item of analytic3">
            <div class="card p-4 h-100" nz-tooltip [nzTooltipTitle]="
              item.number === 0
                ? ('analytic3.noDataExist' | translate)
                : (item.tooltip | translate)
            " nzTooltipPlacement="bottom">
              <div class="card-title">
                <p class="icon">
                  <img *ngIf="item.icon" [src]="item.icon" width="40" height="40" />
                </p>
                <span class="title" style="color: black">
                  {{ item.title | translate }}
                </span>
              </div>

              <p class="number">{{ item.number }}</p>

              <div class="progress-content">
                <p class="increase" *ngIf="item.percentage > 0">
                  <i class="fa-solid fa-arrow-up"></i>
                  <span>{{ item.percentage }}%</span>
                </p>
                <p class="decrease" *ngIf="item.percentage < 0">
                  <i class="fa-solid fa-arrow-down"></i>
                  <span>{{ item.percentage }}%</span>
                </p>
                <p class="progress-text">
                  {{ item.progressText | translate }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h1></h1>
        </div>
        <div class="search-input-wrapper">
          <input type="text" [placeholder]="'contests.search' | translate" class="form-control" [(ngModel)]="searchTerm"
            (input)="onSearch()" autocapitalize="off" style="text-transform: none;" />
          <div class="icon-wrapper">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z">
              </path>
            </svg>
          </div>
        </div>
      </div>
      <div class="table-container mt-4">
        <div class="table-content">
          <app-table [showAction]="false" [listOfData]="displayData" [columns]="columns" [isPagination]="false"
            [nzScrollWidth]="'auto'">
            <ng-template let-columns>
              <thead>
                <tr>
                  <th *ngFor="let col of columns" [style.width]="col.width">
                    {{ col.name | translate }}
                  </th>
                </tr>
              </thead>
            </ng-template>
          </app-table>
        </div>
      </div>
    </div>
  </section>

  <!-- Filter Modal ko config pass karo -->
  <app-filter-modal [(isVisible)]="isFilterVisible" [config]="filterConfig" [initialFilters]="appliedFilters"
    (filtersApplied)="handleFiltersApplied($event)" (filtersReset)="handleFiltersReset()">
  </app-filter-modal>
</div>